import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Restaurant} from '../../../core/models/restaurant.model';

@Component({
  selector: 'app-order-only-modal',
  templateUrl: './order-only-modal.component.html',
  styleUrls: ['./order-only-modal.component.scss'],
})
export class OrderOnlyModalComponent implements OnInit {
  public restaurant: Restaurant = new Restaurant();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.restaurant = data.restaurant;
  }

  ngOnInit() {}

}
